/*
  component: layout-split-view
  title: Layout Split View
  methods: setLayout(doc), setSectionContent(id, html)
  deps: layout-split utils
*/
import { migrateToV2, collectSections } from '../utils/layout-split.js';

class LayoutSplitView extends HTMLElement {
  constructor() {
    super();
    this._layout = null;
    this._content = new Map();
  }

  connectedCallback() {
    this.render();
  }

  setLayout(doc) {
    this._layout = doc ? migrateToV2(doc) : null;
    this.render();
  }

  setSectionContent(sectionId, html) {
    this._content.set(sectionId, html);
    const slot = this.querySelector(`[data-section-id="${sectionId}"] .layout-split-view-slot`);
    if (slot) {
      slot.innerHTML = html;
    }
  }

  _renderNode(node) {
    if (!node) return '';

    if (node.type === 'leaf') {
      if (!node.section) return '';
      const { id } = node.section;
      return `
        <div class="layout-split-leaf" data-section-id="${id}">
          <div class="layout-split-view-slot">${this._content.get(id) || ''}</div>
        </div>
      `;
    }

    if (node.type === 'split') {
      const dirClass = node.direction === 'row'
        ? 'layout-split-node--row'
        : 'layout-split-node--col';
      return `
        <div class="layout-split-node ${dirClass}">
          ${node.children.map((child) => `
            <div class="layout-split-pane">${this._renderNode(child)}</div>
          `).join('')}
        </div>
      `;
    }

    return '';
  }

  render() {
    if (!this._layout?.root) {
      this.innerHTML = '';
      return;
    }

    const sections = collectSections(this._layout.root);
    if (!sections.length) {
      this.innerHTML = '';
      return;
    }

    this.innerHTML = `
      <div class="layout-split-view-root">
        ${this._renderNode(this._layout.root)}
      </div>
    `;
  }
}

customElements.define('layout-split-view', LayoutSplitView);
